module.exports = __webpack_public_path__ + "media/site_templates/www.localcleaners.net.au/images/logo-fbf20cd1ba5b3abf6c39ba92066aa818.svg";